export type MockProduct = {
    barcode: string;
    name: string;
    sku: string;
    color: string;
    size: string;
    status: string;
};

const MOCK_CATALOG: Omit<MockProduct, 'barcode'>[] = [
    {
        name: 'Basic Crew Neck T-Shirt',
        sku: 'TSH-BASIC-001',
        color: 'Navy',
        size: 'M',
        status: 'Aktif',
    },
    {
        name: 'Slim Fit Denim Jeans',
        sku: 'JNS-SLIM-214',
        color: 'Indigo',
        size: '32',
        status: 'Aktif',
    },
    {
        name: 'Quilted Puffer Jacket',
        sku: 'JKT-PUF-088',
        color: 'Black',
        size: 'L',
        status: 'Demo stok',
    },
];

/** Deterministic mock product from barcode digits (demo only). */
export const resolveMockProduct = (barcode: string): MockProduct => {
    const trimmed = barcode.trim();
    const digits = trimmed.replace(/\D/g, '');
    const index = digits ? Number(digits.slice(-2)) % MOCK_CATALOG.length : 0;
    const base = MOCK_CATALOG[index] ?? MOCK_CATALOG[0];

    return {
        barcode: trimmed,
        ...base,
    };
};
